// import { useTranslation } from "react-i18next";
import { LegalSection, LegalParagraph } from "./index";

/**
 * 隱私權政策內容組件
 * 顯示 Mayi AI 的隱私權政策內容
 */
export function PrivacyContent() {
  // const { t } = useTranslation();

  return (
    <div>
      <LegalSection title="1. 導言">
        <LegalParagraph>
          歡迎使用{" "}
          <strong className="font-semibold text-[#6B8E5A]">麻薏 Mayi AI</strong>
          ！本隱私權政策說明我們如何處理您的個人資料。
        </LegalParagraph>
        <LegalParagraph>
          我們非常重視您的隱私，並致力於保護您的個人資料。
        </LegalParagraph>
        <LegalParagraph>
          使用我們的服務即表示您同意本隱私權政策中說明的資料處理方式。
        </LegalParagraph>
        <LegalParagraph>
          如您不同意本政策的任何部分，請勿使用我們的服務。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="2. 我們收集的資料">
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            2.1 您提供的資料：
          </strong>{" "}
          包括您在註冊、使用我們的服務或與我們聯繫時提供的資料，如姓名、電子郵件、密碼、個人網站需求等。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            2.2 自動收集的資料：
          </strong>{" "}
          包括您的 IP 位址、瀏覽器類型、裝置資訊、使用時間、點擊及瀏覽記錄等。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            2.3 Cookie 及類似技術：
          </strong>{" "}
          我們使用 Cookie
          及類似技術來追蹤您的偏好設定、保持登入狀態並提供個人化的體驗。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="3. 資料使用方式">
        <LegalParagraph>我們使用您的個人資料來：</LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            3.1 提供服務：
          </strong>{" "}
          包括建立及維護您的帳戶、提供您所要求的服務、處理交易以及回應您的詢問。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            3.2 改善服務：
          </strong>{" "}
          分析使用資料以改善我們的服務、開發新功能及提升用戶體驗。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">3.3 通訊：</strong>{" "}
          向您發送服務相關通知、更新及安全警報。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            3.4 希望收到的行銷資訊：
          </strong>{" "}
          在獲得您的同意下，我們可能會向您發送行銷資訊。您可以隨時選擇退出收取這些資訊。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="4. 資料共享">
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            4.1 服務提供商：
          </strong>{" "}
          我們可能與協助我們提供服務的第三方共享資料，如雲端伺服器、支付處理商等。這些第三方只能根據我們的指示處理您的資料。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            4.2 法律要求：
          </strong>{" "}
          如果法律要求，我們可能會共享您的資料，例如回應法律程序、執行法律要求或保護我們的合法權益。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            4.3 其他情況：
          </strong>{" "}
          在獲得您的同意下，我們可能會在其他情況下共享您的資料。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="5. 資料安全">
        <LegalParagraph>
          我們採取適當的技術及組織措施來保護您的個人資料免受未經授權的存取、使用或揭露。然而，網路傳輸沒有任何系統是完全安全的，我們無法保護您的資料絕對安全。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="6. 您的權利">
        <LegalParagraph>
          針對我們持有的您的個人資料，您依法享有以下權利：
        </LegalParagraph>

        <LegalParagraph>
          查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除。
        </LegalParagraph>

        <LegalParagraph>
          若您欲行使上述權利，請透過 support@mayiai.co
          與我們聯繫。我們將在驗證您的身分後，依法處理您的請求。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="7. 隱私權政策變更">
        <LegalParagraph>
          我們可能隨時修訂本隱私權政策。若有重大變更，我們將透過您提供的 Email
          或在本服務網站上公告通知。建議您定期查看本政策。您在變更後繼續使用本服務，將視為您已同意接受修訂後的政策。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="8. 聯絡我們">
        <LegalParagraph>
          若您對本隱私權政策有任何疑問或建議，歡迎透過以下方式與我們聯繫：
          <br />
          Email: support@mayiai.co
        </LegalParagraph>
      </LegalSection>
    </div>
  );
}
